// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Header_Logo__2sn6y","MainContainer":"Header_MainContainer__2kVjp","LinkHome":"Header_LinkHome__AqKF6"};